import { useEffect, useState } from "react";
import DeleteModal from "./EmploymentHistoryDeleteModal";

const InstitutionHistoryTable = ({ data, deleteData, reviewEditClick }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedInstitute, setSelectedInstitute] = useState({})

  let pageSize = 5;
  let totalPage = Math.ceil(data.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const parseMonthYear = (str) => {
    if (str === "") return Date.now();
    if (!str) return "";
    const [month, year] = str?.split("/").map(Number);
    return new Date(year, month - 1);
  };
  const currentItems = [...data]
    .sort((a, b) => parseMonthYear(b.end_Date) - parseMonthYear(a.end_Date))
    .slice(startIndex, startIndex + pageSize);

  const handleNext = () => {
    setCurrentPage((prev) => prev + 1);
  };
  const handlePrev = () => {
    setCurrentPage((prev) => prev - 1);
  };
  const closeDeleteModal = () =>{
    setShowModal(false)
  }
  const handleClose = (institute, key) =>{
    setSelectedInstitute(institute)
    setShowModal(true)
    hideMenu(key)
  }
  const handleDeleteClick = () =>{
    deleteData(selectedInstitute)
    closeDeleteModal()
  }
  
  const handleReviewEditClick = (institute, key) => {
    reviewEditClick(institute);
    hideMenu(key)
  };

  const showMenu = (mnuId) => {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("show")) {
        openDropdown.classList.remove("show");
      }
    }
    document.getElementById("mnuDropDown" + mnuId).classList.toggle("show");
  };

  const hideMenu = (mnuId) => {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("show")) {
        openDropdown.classList.remove("show");
      }
    }
    document.getElementById("mnuDropDown" + mnuId).classList.toggle("hide");
  }

  useEffect(() => {
    if (data.length === 5) setCurrentPage(1);
  }, [data]);

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          {data.length > 0 && (
            <>
              {currentItems.map((institute, index) => {
                return (
                  <>
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{
                          width: "150px",
                          overflowWrap: "break-word",
                          flexDirection: "column",
                          display: "flex",
                        }}
                      >
                        {institute.institution_Name}
                        <span>
                          {institute.city},{" "}
                          {institute.country === "US"
                            ? institute.state
                            : institute.country}
                        </span>
                      </span>
                      <span style={{ width: "60px" }}>
                        {institute.start_Date}
                      </span>
                      <span style={{ width: "60px" }}>
                        {institute.currentInstitutionCheck
                          ? "Present"
                          : institute.end_Date}
                      </span>
                      <span style={{ width: "200px" }}>{institute.degree}</span>
                      <span
                        style={{
                          width: "100px",
                          overflowWrap: "break-word",
                          flexDirection: "column",
                          display: "flex",
                        }}
                      >
                        {institute.majorIn}
                      </span>
                      <span>
                        <div className="address-quick-action-wrapper">
                          <button
                            id="dropbtn"
                            style={{ border: "0" }}
                            className="icon-md icon-more"
                            aria-label="Review/Edit show menu"
                            onClick={() => showMenu(index)}
                          />
                          <div
                            id={"mnuDropDown" + index}
                            className="dropdown-content"
                          >
                            <span
                              id="mnuLinkReview"
                              role="presentation"
                              onClick={() => handleReviewEditClick(institute, index)}
                              className="menu-item-hover"
                            >
                              Review/Edit
                            </span>
                            <span
                              id="mnuLinkDelete"
                              role="presentation"
                              onClick={() => handleClose(institute, index)}
                              style={{ textAlign: "left" }}
                              className="menu-item-hover"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                    <hr />
                  </>
                );
              })}
              { data.length > 5 && 
              <div style={{display:"flex", justifyContent:"end"}}>
                <button onClick={handlePrev} disabled={currentPage === 1} style={{marginRight:"10px"}}>
                  {"<"}
                </button>
                <span>{currentPage}</span>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPage}
                  style={{marginLeft:"10px"}}
                >
                  {">"}
                </button>
              </div>
              }
            </>
          )}
        </div>
      </div>
      <DeleteModal
        message={"Are you sure you'd like to delete this Institution detail?"}
        isOpen={showModal}
        closeClick={closeDeleteModal}
        deleteClick={handleDeleteClick}
        show_spinner={false}
      />
    </div>
  );
};
export default InstitutionHistoryTable;
